// @ts-nocheck

import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import { when } from "lit/directives/when.js"
const { apiFetch } = window.wp

export class ProductListing extends LitElement {
	static properties = {
		product: { type: Object },
	}

	constructor() {
		super()
		this.product = {}
	}

	createRenderRoot() {
		return this
	}

	connectedCallback() {
		super.connectedCallback()
	}

	showVat() {
		// check cookie cirkularfabriken_display_vat
		const value = `; ${document.cookie}`
		const parts = value.split(`; cirkularfabriken_display_vat=`)
		if (parts.length === 2) {
			const cookie = parts.pop().split(";").shift()
			return cookie === "1"
		}
		return false
	}

	formatPrice(price) {
		if (!price) return ""
		const numPrice = typeof price === "string" ? parseFloat(price) : price
		return numPrice.toFixed(2).replace(".", ",")
	}

	getPrices() {
		if (this.showVat()) {
			return {
				current: this.product?.prices?.price / 100,
				regular: this.product?.prices?.regular_price / 100,
			}
		}
		return {
			current: this.product?.extensions?.cf?.price_excl_vat,
			regular: this.product?.extensions?.cf?.regular_price_excl_vat,
		}
	}

	render() {
		const { current, regular } = this.getPrices()
		const onSale =
			this.product?.on_sale && parseFloat(regular) > parseFloat(current)

		return html`
			<a class="product-card" href="${this.product?.permalink || "#"}">
				${this.product?.images?.length > 0 &&
				html`<img
					src="${this.product.images[0].src}"
					alt="${this.product?.name || ""}"
					class="product-image" />`}
				<div class="product-info">
					<div class="product-title-wrap">
						<h2 class="product-title">
							${unsafeHTML(this.product?.name || "")}
						</h2>
						<span>
							${this.product.extensions?.cf.stock_quantity > 0
								? html`<span class="in-stock"
										>${this.product?.extensions?.cf.stock_quantity} i
										lager</span
									>`
								: html`<span class="out-of-stock">Slut i lager</span>`}
						</span>
					</div>
					<div class="product-meta">
						<div>
							<p class="product-subtitle">Pris från</p>
							${onSale
								? html`<del
											aria-hidden="true"
											style="display:block;font-size:0.8em;font-weight:400;color:#8a8f8c;text-decoration:line-through;"
											>${this.formatPrice(regular)} kr</del
										>
										<bdi class="product-price"
											><ins style="text-decoration:none;"
												>${this.formatPrice(current)} kr</ins
											></bdi
										>`
								: html`<bdi class="product-price"
										>${this.formatPrice(current)} kr</bdi
									>`}
						</div>
						<p class="product-tax">
							${when(
								this.showVat(),
								() => html`inkl. moms`,
								() => html`exkl. moms`,
							)}
						</p>
					</div>
				</div>
			</a>
		`
	}
}
